import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle, Button, Label, Textarea } from '@ncoder/ui';
import { MessageCircle } from 'lucide-react';

interface InteractiveTestProps {
  testMessage: string;
  isRunning: boolean;
  onMessageChange: (value: string) => void;
  onSendTest: () => void;
}

export const InteractiveTest: React.FC<InteractiveTestProps> = ({
  testMessage,
  isRunning,
  onMessageChange,
  onSendTest,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Interactive Testing</CardTitle>
        <CardDescription>Test your agent with custom messages</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="test-message">Test Message</Label>
          <Textarea
            id="test-message"
            placeholder="Enter your test message here..."
            value={testMessage}
            onChange={(e) => onMessageChange(e.target.value)}
            rows={3}
          />
        </div>
        <Button 
          onClick={onSendTest} 
          disabled={!testMessage || isRunning}
        >
          <MessageCircle className="h-4 w-4 mr-2" />
          Send Test Message
        </Button>
        
        {isRunning && (
          <div className="p-4 bg-muted rounded-lg">
            <p className="text-sm font-medium mb-2">Agent Response:</p>
            <p className="text-sm text-muted-foreground italic">
              Processing your message...
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
